import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { NoRouteComponent } from '../../components/no-route/no-route.component';
import { CrowdinOtaService } from '../../../../services/crowdin-ota/crowdin-ota.service';
import { LanguageService } from '../../../../services/language.service';
import { TranslationService } from '../../../../services/translation.service';

@Component({
    selector: 'app-legal-page',
    templateUrl: './legal-page.component.html',
    styleUrls: ['./legal-page.component.scss'],
    imports: [TranslateModule, NoRouteComponent],
    standalone: true
})
export class LegalPageComponent implements OnInit {

  isNotFound: boolean = false;
  _language: string = 'en-GB';
  translationData: any;
  content: string = 'CP_LEGAL_TEMPLATE';
  isTranslationDone: boolean = false;

  constructor(private readonly _translationService: TranslationService,
    private readonly _actRoute: ActivatedRoute,
    private readonly _crowdinService: CrowdinOtaService,
    private readonly languageService: LanguageService, private readonly router:Router) {
    const langId = this.languageService.getLanguage();
    const userLang = navigator.language;
    if (!langId || !this.languageService.checkIsValideLanguage(langId)) {
      this.isNotFound = true;
    } else {
      this.isNotFound = false;
      this._language = langId && this.languageService.checkIsValideLanguage(langId) ? langId :
      (userLang && this.languageService.checkIsValideLanguage(userLang) ? userLang : 'en-GB');
    }
    this._translationService.sharetranslationData.subscribe((data: any) => {
      this.translationData = data;
      this.isTranslationDone = true;
    });
  }

  ngOnInit(): void {
    if(this.router.url.includes('terms-conditions')){
      this.content= 'CP_TERMS_CONDITION_TEMPLATE'
    }else{
      this.content = 'CP_LEGAL_TEMPLATE';
    }
      const languageCode = this._language.split('-')[0];
      this._crowdinService.useLanguage(languageCode);
  }


}
